import { useNavigate } from 'react-router-dom';
import { Card, CardBody, Container } from 'reactstrap';

const CheckoutCancel = () => {
    const navigate = useNavigate();

    const handleRetry = () => {
        navigate('/register');
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="auth-page-wrapper pt-5">
            <div className="auth-page-content">
                <Container>
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <Card className="mt-4">
                                <CardBody className="p-4 text-center">
                                    <div className="avatar-lg mx-auto mb-4">
                                        <div className="avatar-title bg-danger-subtle text-danger display-3 rounded-circle">
                                            <i className="fa fa-light fa-circle-xmark"></i>
                                        </div>
                                    </div>
                                    <h4 className="text-danger">Payment Cancelled</h4>
                                    <p className="text-muted mb-4">
                                        Your payment was cancelled. No charges have been made to your account.
                                    </p>
                                    <p className="text-muted small mb-4">
                                        If you experienced any issues during checkout, please try again or contact our support team for assistance.
                                    </p>
                                    <div className="d-flex gap-2 justify-content-center">
                                        <button
                                            className="btn btn-primary"
                                            onClick={handleRetry}
                                        >
                                            <i className="fa fa-light fa-rotate-right me-1"></i>
                                            Try Again
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={handleGoHome}
                                        >
                                            Go Home
                                        </button>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default CheckoutCancel;
